const SCROLL_DELTA = 100;

export default class Scrollable {
  constructor($container) {
    this.$container = $container;
    this.$inner = $container.querySelector('.scrollable-inner');
    
    const $buttons = $container.querySelectorAll('.scrollable-navigation div');
    for (const $button of $buttons) {
      $button.addEventListener('click', this.onNavButtonClick.bind(this));
    }

    this.containerHeight = 0;

    this.innerHeight = 0;

    this.isScrollable = true;

    this.isAtTop = false;

    this.isAtBottom = false;

    this.currentPosition = 0;
  }

  resize() {
    this.containerHeight = this.$container.getBoundingClientRect().height;
    this.innerHeight = this.$inner.getBoundingClientRect().height;

    this.checkScrollability();
  }

  onNavButtonClick(e) {
    const direction = e.currentTarget.classList.value.indexOf('-down') > -1 ? 1 : -1;
    const newPosition = Math.min(Math.max(0, this.currentPosition + direction * SCROLL_DELTA), this.innerHeight - this.containerHeight + SCROLL_DELTA);

    this.currentPosition = newPosition; 
    this.$inner.style.transform = `translate3d(0, ${-this.currentPosition}px, 0)`;

    this.checkScrollability();    
  }

  checkScrollability() {    
    const isScrollable = this.innerHeight > this.containerHeight;

    if (isScrollable !== this.isScrollable) {
      this.$container.setAttribute('data-is-scrollable', isScrollable);
      this.isScrollable = isScrollable;
    }

    const isAtTop = this.currentPosition === 0;
    const isAtBottom = this.currentPosition === this.innerHeight - this.containerHeight + SCROLL_DELTA;
    
    if (isAtTop !== this.isAtTop) {
      this.isAtTop = isAtTop;
      this.$container.setAttribute('data-is-at-top', isAtTop);
    }

    if (isAtBottom !== this.isAtBottom) {
      this.isAtBottom = isAtBottom;
      this.$container.setAttribute('data-is-at-bottom', isAtBottom);
    }  
  }
}